import React from "react";
import './ExperiencePage.css';
import ExperienceSection from "../../Sections/ExperienceSection/ExperienceSection";

export default function ExperiencePage(){
    return(
        <>
            <ExperienceSection/>
        </>
    );
}